<script>
    import {
        dropHash,
        pending,
        requested,
        highestId,
        amOwner,
        me,
        cleanAddress,
        state,
        approvals,
        drops,
        isValidToken,
        tokenMetadata,
        requestDropContractMetadata,
        requestDropTokenMetadata,
        setApprovalForAll,
        getApproval,
        registerDrop, isValidAddress, onRegisterDrop, onTransactionConfirm
    } from "../stores/contracts";

    import {elements, ion_names, ion_list, probabilities} from "../stores/elementData";

    import {address} from "../stores/wallet.js";
    import TokenImage from "../components/TokenImage.svelte";
    import Spinner from "../components/Spinner.svelte";
    import DropListing from "../components/DropListing.svelte";
    import {navigateTo} from "svelte-router-spa";
    import Window from "../components/Window.svelte";

    export let depth;
    export let toFront = ()=>{};
    export let minimise = ()=>{};
    export let finishAdd = (tokenAddress,dropTokenId)=>{};
    export let active;

    let tokenAddress = "";
    let tokenAddressInput = "";
    let tokenValid = 'initial';
    let tokenId = 0;
    let tokenIdInput = "";
    let owned = 'initial'

    let metadata = {};


    let approved = 'initial';
    let condition = 'element';

    let name = "", symbol = "";

    let _me = me;

    let otherDrops = [];

    let requiredTokenId = 1;
    let requiredTokenIdInput = '';


    let element = 1;
    let elementInput = 1;
    let ion = 0;
    let ionInput = '0';
    let ions = [];
    let probability = ""

    let validated = false;
    let validationError = "";

    let transacting = false;
    let txRequested = false;
    let txPending = false;

    function doCreateDrop() {
        switch (condition) {
            case "tokenId":
                registerDrop(tokenAddress, tokenId, 0, 0, false, requiredTokenId);
                break;
            case "element":
                registerDrop(tokenAddress, tokenId, element, 0, false, 0);
                break;
            case "ionCharge":
                registerDrop(tokenAddress, tokenId, 0, parseInt(ion), false, 0);
                break;
            case "elementAndIon":
                registerDrop(tokenAddress, tokenId, element, parseInt(ion), false, 0);
                break;
            case "isIon":
                registerDrop(tokenAddress, tokenId, 0, 0, true, 0);
                break;
        }
        //
    }

    async function checkTokenAddress() {
        let address = tokenAddress;
        try {
            tokenValid = 'checking';
            let valid = await isValidToken(tokenAddress);
            if (tokenAddress === address) {
                if (valid) {
                    tokenValid = "valid";
                    requestDropContractMetadata(tokenAddress);
                    getApproval(tokenAddress);
                } else {
                    tokenValid = 'invalid';
                }
            }
        } catch (e) {
            tokenValid = 'invalid';
        }
    }

    async function checkTokenId() {
        let id = tokenId;
        try {
            owned = "checking";
            let isOwned = await amOwner(tokenAddress, id);
            if (tokenId === id) {
                if (isOwned) {
                    owned = "owned";
                    requestDropTokenMetadata(tokenAddress, id);
                } else {
                    owned = "unowned";
                }
            }
        } catch (e) {
            owned = "invalid";
            console.log(e);
        }
    }


    function updateAddress() {
        if (tokenAddress === tokenAddressInput) return;
        tokenAddress = cleanAddress(tokenAddressInput);
        checkTokenAddress();
    }

    function updateTokenId() {
        if (parseInt(tokenIdInput) === tokenId) return;
        tokenId = parseInt(tokenIdInput);
        checkTokenId();
    }

    onTransactionConfirm((func, params) => {
        if (func !== "registerDrop") return;
        // console.log(">>>");
        // console.log(func);
        // console.log(params);
        finishAdd(params.tokenAddress,params.dropTokenId);
        // navigateTo("/Drop/" + params.tokenAddress + "/" + params.dropTokenId);
    });

    // function resetToken(){
    //     name = "";
    //     symbol = "";
    // }

    function approve() {
        setApprovalForAll(tokenAddress);
    }

    $:{
        if ($state !== "initial") {


            if (tokenAddress.length > 0 && !isNaN(parseInt(tokenId)) && isValidAddress(tokenAddress)) {
                let _dropHash = dropHash(tokenAddress, tokenId);
                txPending = $pending.registerDrop[_dropHash];
                txRequested = $requested.registerDrop[_dropHash];
            } else {
                txPending = false;
                txRequested = false;
            }
            transacting = txPending || txRequested;

            otherDrops = [];
            if ($tokenMetadata[tokenAddress]) {
                name = $tokenMetadata[tokenAddress].name;
                symbol = $tokenMetadata[tokenAddress].symbol;

                if ($tokenMetadata[tokenAddress].tokens[tokenId]) {
                    metadata = $tokenMetadata[tokenAddress].tokens[tokenId];
                } else {
                    metadata = {
                        state: "initial",
                        name: "",
                        description: "",
                        image: "",
                    };
                }
                for (let id in $drops[tokenAddress]) {
                    requestDropTokenMetadata(tokenAddress, id);
                    let _drop = {
                        atomicNumber: $drops[tokenAddress][id].atomicNumber,
                        ionCharge: $drops[tokenAddress][id].ionCharge,
                        isIon: $drops[tokenAddress][id].isIon,
                        tokenId: $drops[tokenAddress][id].tokenId,
                        blockNumber: $drops[tokenAddress][id].blockNumber,
                        probability: $drops[tokenAddress][id].probability,

                        tokenAddress: tokenAddress,
                        dropTokenId: id,
                    }
                    // console.log(_drop);
                    // otherDrops.push(
                    //     {
                    //         id: id,
                    //         drop: _drop,
                    //     }
                    // )
                }

            } else {
                name = "";
                symbol = "";
                metadata = {
                    state: "initial",
                    name: "",
                    description: "",
                    image: "",
                };
            }

            if (!$approvals[tokenAddress]) {
                approved = "initial";
            } else {
                approved = String($approvals[tokenAddress]);
            }

            _me = me;
            processConditionInput();
        }
    }

    function delayProcessConditionInput() {
        setTimeout(processConditionInput, 100);
    }

    function processConditionInput() {
        // console.log("condition:", condition)
        switch (condition) {
            case "tokenId":
                element =
                    elementInput = '1';
                ion =
                    ionInput = '0';
                break;
            case "element":
                ion =
                    ionInput = '0';
                break;
            case "ionCharge":
                element =
                    elementInput = '1';
                if (ionInput === "0") {
                    ion =
                        ionInput = "+1";
                }
                break;
            case "elementAndIon":
                if (ion_names[elementInput].length === 0) {
                    ion =
                        ionInput = "0";
                } else if (!ion_names[elementInput].includes(ionInput)) {
                    ion =
                        ionInput = ion_names[elementInput][0];
                }

                break;
            case "isIon":
                element =
                    elementInput = '1';
                ion =
                    ionInput = '0';
                break;
        }


        //////


        // if(condition === "elementAndIon" && typeof ion_names[elementInput][ionInput] === "undefined"){
        //     if(ion_names[elementInput].length > 0){
        //         ionInput = ion_names[elementInput][0];
        //     }else{
        //         ionInput = "0";
        //     }
        // }
        if (condition === "tokenId") {
            requiredTokenId = requiredTokenIdInput;
        }

        if (condition === "element" || condition === "elementAndIon") {
            element = elementInput;
        } else {
            element = '1';
        }
        // console.log('?>>', element);

        if (condition === "ionCharge" || condition === "elementAndIon") {
            ion = ionInput;
        } else {
            ion = '0';
        }
        // console.log('ion:', ion);
        // console.log('ionInput:', ionInput);
        //

        if (condition === "ionCharge") {
            ions = ion_list;
        } else {
            if (ion_names[element]) {
                ions = ion_names[element];
            } else {
                ions = ion_names[element];

            }
        }

        //probability && validation
        if (condition === "element") {
            if (probabilities.element[element]) {
                probability = (Math.round(probabilities.element[element] * 10000) / 100).toString() + "%";
                validated = true;
            } else {
                validated = false;
                validationError = "Element does not exist";
                probability = "Void";
            }
        } else if (condition === "ionCharge") {
            if (probabilities.ionCharge[ion]) {
                probability = (Math.round(probabilities.ionCharge[ion] * 10000) / 100).toString() + "%";
                validated = true;
            } else {
                validated = false;
                validationError = "Ion does not exist";
                probability = "Void";
            }
        } else if (condition === "elementAndIon") {
            if (ions.length > 0 && probabilities.elementAndIon[element] && probabilities.elementAndIon[element][ion]) {
                probability = (Math.round(probabilities.elementAndIon[element][ion] * 10000) / 100).toString() + "%";
                validated = true;
            } else {
                validated = false;
                if (probabilities.elementAndIon[element].length === 0) {
                    validationError = "Element can not ionise";
                } else {
                    validationError = "Element can not have this charge";
                }
                probability = "Void";
            }
        } else if (condition === "isIon") {
            probability = (Math.round(probabilities.isIon * 10000) / 100).toString() + "%";
            validated = true;
        } else {
            probability = "Fixed";

            if (requiredTokenIdInput === "") {
                validated = false;
                validationError = "Please specify a tokenId";
            } else if (!isNaN(requiredTokenId)) {
                validated = false;
                validationError = "Not a valid number";
            }
            if (requiredTokenId <= $highestId) {
                validated = false;
                validationError = "TokenId must be greater than " + $highestId;
            } else if (requiredTokenId >= $highestId + 100) {
                validated = false;
                validationError = "TokenId must be less than " + ($highestId + 100);
            } else {
                validated = true;
            }
        }

        ///Validation


    }

</script>


<style>
    .addDrop{
        display: flex;
        flex-direction: row;
    }
    .tokenInfo{
        background: black;
        width:560px;
        height: 720px;
    }
    .tokenDetails{
        color: white;
        display: flex;
        flex-direction: column;

        /*background: red;*/
        padding: 15px;
        row-gap: 10px;
        /*width:320px;*/
    }
    .tokenDetails span{
        color:white;
        font-family: sans-serif;
        text-overflow: ellipsis;
        font-size:16px;

        /*overf*/
        /*width:100%;*/
        width:500px;
    }
    .contractDetails{
        white-space: nowrap;
        overflow:hidden;
    }
    .tokenName{
        white-space: nowrap;
        overflow:hidden;
    }

    .tokenDescription{
        height:80px;
        overflow:hidden;
        padding-right:40px;
    }


    .controlSection{
        display: flex;
        flex-direction: column;
        width:250px;
        align-items: flex-start;
        padding-left: 30px;
    }
    h2{
        width:250px;
        text-align: center;
        padding-bottom: 20px;
        font-size: 30px;
        font-weight: normal;
    }
    h3{
        width:250px;
        /*text-align: center;*/
        padding-bottom: 20px;
    }
    .input-section{
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        padding-bottom:30px;
    }
    .input-label{
        padding-bottom: 5px;
    }
    .input-field{
        padding-left:5px;
        width:245px;
        text-align: left;
        color:white;
        font-weight: normal;
        background: #242424;
        font-size: 20px;
    }
    .input-field:active{
        border:none;
    }
    .input-field:focus{
        /*border-radius: 0;*/
        /*border: red 2px solid;*/
    }

    .linkBox{
        display: inline-block;
        text-align: center;
        width:250px;
        text-decoration: none;
        color:black;
        background: #dbdbdb;
        border-left:    solid white 2px;
        border-top:     solid white 2px;
        border-bottom:  solid black 2px;
        border-right:   solid black 2px;
    }
    .linkBox:visited{
        color:black;

    }
    .linkBox:hover{
        background: #f0f0f0;
        text-decoration: none;
    }
    .linkBox:active{
        background: #c8c8c8;
        border-left:    solid black 2px;
        border-top:     solid black 2px;
        border-bottom:  solid white 2px;
        border-right:   solid white 2px;
    }

    .submitBox{
        background: #00ff99;
    }
    .submitBox:hover{
        background: #87ffcc;
    }
    .submitBox:active{
        background: #9cffd3;
    }


    .marginTop20{
        margin-top: 20px;
    }
    .marginBottom20{
        margin-bottom: 20px;
    }

    .input-validation{
        margin-top: 20px;
    }

    .input-select{
        width:250px;
        text-align: center;
    }

    .description-prompt{
        width:250px;
        text-align: center;
    }
    .subheader{
        width: 250px;
        font-size: 22px;
        margin-bottom: 20px;
        font-weight: bold;
        text-align: center;
    }
    .bold{
        font-weight: bold;
    }

    .readout-probability{
        width: 250px;
        text-align: center;
        margin-bottom:20px;
    }

    .validation-fail{
        color: darkred;
    }
    .load-prompt{
        font-size: 30px;
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    .centrise{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width:100%;
        min-width: 810px;
    }
</style>

<Window depth={depth} toFront={toFront} active={active} name="ADD DROP"  minimise={minimise}>

<!--    <h1>Create drop</h1>-->

    <div class="centrise">

    {#if $state === "initial"}
        <div class="load-prompt">
            You must connect Metamask or another Web3 wallet in order to create a drop.
        </div>
    {:else if $state === "loading"}
        <div class="load-prompt">
           Connecting to drop contract...
        </div>
    {:else if $state === "network"}
        <div class="load-prompt validation-fail">
            Please connect to the Ethereum mainnet.
        </div>
    {:else if $state === "error"}
        <div class="load-prompt validation-fail">
            Error connecting to contract with Web3 wallet.
        </div>
    {:else}
        <div class="addDrop">
            <div class="tokenInfo boxIn">
                {#if owned === "initial"}
                    <TokenImage forceState="initial" displayType="focus"/>
                    <div class="tokenDetails">
                        <span class="contractDetails">Contract: {name}</span>
                        <span class="tokenName">Title:</span>
                        <span class="tokenDescription">Description:</span>
                    </div>
                {:else if owned === "pending" || owned === "checking"}
                    <TokenImage forceState="loading" displayType="focus"/>
                    <div class="tokenDetails">
                        <span class="contractDetails">Contract: {name}</span>
                        <span class="tokenName">Title: ...</span>
                        <span class="tokenDescription">Description: ...</span>
                    </div>
                {:else if owned === "invalid"}
                    <TokenImage forceState="fail" displayType="focus"/>
                    <div class="tokenDetails">
                        <span class="contractDetails">Contract: {name}</span>
                        <span class="tokenName">Error</span>
                        <span class="tokenDescription"></span>
                    </div>
                {:else if owned === "unowned"}
                    <TokenImage forceState="unloaded" displayType="focus"/>
                    <div class="tokenDetails">
                        <span class="contractDetails">Contract: {name}</span>
                        <span class="tokenName">Not your token</span>
                        <span class="tokenDescription"></span>
                    </div>
                {:else }
                    {#if metadata.state === "loaded"}
                        <TokenImage src="{metadata.image}" displayType="focus"/>
                        <div class="tokenDetails">
                            <span class="contractDetails">Contract: {name}</span>
                            <span class="tokenName">Title: {metadata.name}</span>
                            <span class="tokenDescription">Description: {metadata.description}</span>
                        </div>

                    {:else if metadata.state === "fail"}
                        {#if metadata.uri === ""}
                            <TokenImage forceState="fail" displayType="focus"/>
                            <div class="tokenDetails">
                                <span class="contractDetails">Contract: {name}</span>
                                <span class="tokenName">Error getting token data. Token not found.</span>
                                <span class="tokenDescription"></span>
                            </div>
                        {:else}
                            <TokenImage forceState="fail" displayType="focus"/>
                            <div class="tokenDetails">
                                <span class="contractDetails">Contract: {name}</span>
                                <span class="tokenName">Error getting token data. Metadata URI failed.</span>
                                <span class="tokenDescription"></span>
                            </div>
                        {/if}

                    {:else}
                        <TokenImage forceState="loading" displayType="focus"/>
                        <div class="tokenDetails">
                            <span class="contractDetails">Contract: {name}</span>
                            <span class="tokenName">Title: ...</span>
                            <span class="tokenDescription">Description: ...</span>
                        </div>
                    {/if}
                {/if}


<!--                <TokenImage src="{tokenImage}" displayType="focus"/>-->
<!--                <div class="tokenDetails-s">-->

<!--                    <span class="contractDetails-s">Contract: {name}</span>-->
<!--                    <span class="tokenName-s">Title: {tokenName}</span>-->
<!--                    <span class="tokenDescription-s">Description: {tokenDescription}</span>-->

<!--                </div>-->
            </div>
            <div class="controlSection">
                <h2>Add DROP</h2>
                <h3>CREATE AN NFT DROP</h3>
                <div>
                    Enter the Token Contract Address. Tokens must be ERC721 compliant NFTs on the Ethereum blockchain.
                </div>
                <div class="input-section">
                    <span class="input-label">Token Contract Address</span>
                    <input
                            class="input-field"
                            disabled={transacting}
                            bind:value={tokenAddressInput}
                            on:change={updateAddress}
                            on:keyup={updateAddress}
                            type="text"/>
                </div>
                {#if tokenValid !== "valid"}
                    <!--        <div id="readout-tokenAddress">-->
                        {#if tokenValid === "checking"}
                            <div class="input-validation">
                                Checking token address...
                            </div>
                        {:else if tokenValid === "invalid"}
                            <div class="validation-fail">
                                Invalid token address. Make sure its an ERC721 compliant NFT on the Ethereum mainnet.
                            </div>
                        {/if}

                <!--0x8B42207478fb7c6d774a6E6d764bF0dcE4759918-->
                {:else }
                    {#if approved === "initial"}
                        <div  class="input-validation"></div>
                    {:else if approved === 'checking'}
                        <div  class="input-validation"> Checking approval... </div>
                    {:else if approved === 'false'}

                        <div class="description-prompt">
                            To add a drop, you must first Approve the POWNFT Drops contract. This is a function of all ERC721 NFT token contracts, and will allow the POWNFT Drops contract to take custody of your NFT when you create the drop.
                        </div>

                        <button class="linkBox marginTop20" on:click={approve}>
                            Approve
                        </button>
                    {:else if approved === "pending"}
                        <div class="description-prompt">
                            To add a drop, you must first Approve the POWNFT Drops contract. This is a function of all ERC721 NFT token contracts, and will allow the POWNFT Drops contract to take custody of your NFT when you create the drop.
                        </div>

                        <div class="input-validation">Approving...</div>
                    {:else}
                        <!--    Approved-->
                        <div class="description-prompt">
                            Enter the TokenID of the NFT you want to ADD.
                        </div>
                        <div class="input-section">
                            <span class="input-label">TokenID (Number)</span>
                            <input
                                    class="input-field"
                                    disabled={transacting}
                                    bind:value={tokenIdInput}
                                    on:change={updateTokenId}
                                    on:keyup={updateTokenId}
                                    type="text"/>
                        </div>

                        {#if owned === "initial"}
                            <div class="input-validation"></div>
                        {:else if owned === "pending" || owned === "checking"}
                            <div class="input-validation">Getting token data...</div>
                        {:else if owned === "invalid"}
                            <div class="input-validation validation-fail">Token invalid</div>
                        {:else if owned === "unowned"}
                            <div class="input-validation validation-fail">You don't own this token</div>
                        {:else }

                            <div class="subheader">
                                SET DROP TRIGGER
                            </div>

                            <div class="description-prompt">
                                Select the conditions under which someone can claim your NFT. The contract will only release it to someone who mines an Atom matching these conditions.
                            </div>

                            <div class="input-section">
                                <span class="input-label bold">CLAIMABLE BY</span>
                                <select
                                        class="input-select"
                                        disabled={transacting}
                                        on:change={delayProcessConditionInput}
                                        bind:value={condition} name="select-condition" id="select-condition">
                                    <option value="element">Element</option>
                                    <option value="ionCharge">Ion Charge</option>
                                    <option value="elementAndIon">Element and Charge</option>
                                    <option value="isIon">Any Ion</option>
                                    <option value="tokenId">POWNFT Token ID</option>
                                </select>
                            </div>

                            {#if condition === "tokenId"}
                                <div class="description-prompt">
                                    Your NFT will be claimable by any Atom mined after a specific token ID. The most recent Atom mined was #{$highestId}. You must specify a number between {$highestId} and {$highestId+100}
                                </div>

                                <div class="input-section">
                                    <span class="input-label  bold">TOKEN ID</span>
                                    <input
                                            class="input-field"
                                            disabled={transacting}
                                            bind:value={requiredTokenIdInput}
                                            on:change={delayProcessConditionInput}
                                            on:keyup={delayProcessConditionInput}
                                            on:keypress={delayProcessConditionInput}
                                            name="input-requiredTokenId"
                                            id="input-requiredTokenId"
                                    />
                                </div>
                            {:else if condition === "element" || condition === "elementAndIon" || condition === "ionCharge" }

                                {#if condition === "element"}
                                    <div class="description-prompt">
                                        Your NFT will be claimable by the next Atom mined that is a specific element.
                                    </div>
                                {:else if condition === "ionCharge"}
                                    <div class="description-prompt">
                                        Your NFT will be claimable by the next Atom mined that has a specific ion charge.
                                    </div>
                                {:else}
                                    <div class="description-prompt">
                                        Your NFT will be claimable by the next Atom mined that is a specific ion of a particular element.
                                    </div>
                                {/if}

                                {#if condition !== "ionCharge"}
                                    <div class="input-section">
                                        <span class="input-label  bold">ELEMENT</span>
                                        <select
                                                class="input-select"
                                                disabled={transacting}
                                                on:change={delayProcessConditionInput}
                                                bind:value={elementInput} name="select-element" id="select-element">
                                            {#each elements as element}
                                                <option value="{element[0]}">{element[2]}</option>
                                            {/each}
                                        </select>
                                    </div>
                                {/if}
                                {#if condition !== "element"}
                                    <div class="input-section">
                                        <span class="input-label  bold">ION CHARGE</span>
                                        <span>
                                        {#if ions.length > 0}
                                            <select
                                                    class="input-select"
                                                    disabled={transacting}
                                                    on:change={delayProcessConditionInput}
                                                    bind:value={ionInput} name="select-ion" id="select-ion">
                                                {#each ions as ion}
                                                    <option value="{ion}">{ion}</option>
                                                {/each}}
                                            </select>
                                        {:else }
                                            No ions for this element
                                        {/if}
                                    </span>
                                    </div>
                                {/if}
                            {:else if condition === "isIon"}
                                <div class="description-prompt marginBottom20">
                                    Your NFT will be claimable by the next Atom mined that is an ion.
                                </div>
                            {/if}
                            <!--                </div>-->

                            <div class="readout-probability">
                                Probability next Atom: {probability}
                            </div>

                            <div class="section-submit">
                                {#if validated}
                                    {#if !transacting}


                                        <button class="linkBox submitBox" href="#" on:click={doCreateDrop}>
                                            Submit
                                        </button>


                                    {:else}
                                        <div class="input-validation">Transacting...</div>
                                    {/if}
                                {:else}
                                    <div class="input-validation validation-fail">
                                        {validationError}
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    {/if}
                {/if}

            </div>
        </div>
    {/if}
    </div>

</Window>
